export const DISPLAY_CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '\u20ac', name: 'Euro' },
  { code: 'JPY', symbol: '\u00a5', name: 'Japanese Yen' },
  { code: 'GBP', symbol: '\u00a3', name: 'British Pound' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
  { code: 'CNY', symbol: '\u00a5', name: 'Chinese Yuan' },
  { code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar' },
  { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar' },
  { code: 'NOK', symbol: 'kr', name: 'Norwegian Krone' },
  { code: 'KRW', symbol: '\u20a9', name: 'South Korean Won' },
  { code: 'INR', symbol: '\u20b9', name: 'Indian Rupee' },
  { code: 'BRL', symbol: 'R$', name: 'Brazilian Real' },
  { code: 'MXN', symbol: '$', name: 'Mexican Peso' },
  { code: 'BTC', symbol: '\u20bf', name: 'Bitcoin' },
  { code: 'ETH', symbol: '\u039e', name: 'Ethereum' },
] as const;

export type DisplayCurrency = typeof DISPLAY_CURRENCIES[number]['code'];

export const isDisplayCurrency = (value: unknown): value is DisplayCurrency =>
  typeof value === 'string' && DISPLAY_CURRENCIES.some(option => option.code === value);

export const getDisplayCurrencySymbol = (currency: DisplayCurrency): string =>
  DISPLAY_CURRENCIES.find(option => option.code === currency)?.symbol ?? '$';

export const convertUsdValue = (
  value: number,
  targetCurrency: DisplayCurrency,
  getPriceBySymbol: (symbol: string) => number
): number => {
  if (targetCurrency === 'USD') return value;

  if (targetCurrency === 'BTC' || targetCurrency === 'ETH') {
    const rate = getPriceBySymbol(`${targetCurrency}USDT`);
    return rate > 0 ? value / rate : value;
  }

  const directRate = getPriceBySymbol(`USD${targetCurrency}`);
  if (directRate > 0) return value * directRate;

  const inverseRate = getPriceBySymbol(`${targetCurrency}USD`);
  if (inverseRate > 0) return value / inverseRate;

  return value;
};
